import { ChatModesButtonGroup } from '@terminal/components/chat-landing/ChatModesButtonGroup';
import { RenderFeatureFlag } from '@terminal/components/render-feature-flag/RenderFeatureFlag';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { ChatMode } from '@terminal/views/alfred/use-chat-navigation/useChatNavigation';
import React, { ReactNode } from 'react';

import { AnalysisModeDropdown } from '../chat-input-fields/AnalysisModeDropdown';
import { WebSearchDropdown } from '../chat-input-fields/web-search/WebSearchDropdown';
import { UploadDropdown } from '../upload-dropdown/UploadDropdown';
import styles from './AlfredTools.module.scss';

export interface AlfredToolsProps {
  isAlfredPage: boolean;
  allowedModes: ChatMode[];
  mode: ChatMode;
  isMessagePending: boolean;
  children?: ReactNode;
  showChildrenInTools: boolean;
  uploadDropdownRef: React.RefObject<HTMLDivElement | null>;
  analysisModeDropdownRef: React.RefObject<HTMLDivElement | null>;
  webSearchDropdownRef: React.RefObject<HTMLDivElement | null>;
}

export const AlfredTools = ({
  isAlfredPage,
  allowedModes,
  mode,
  isMessagePending,
  children,
  showChildrenInTools,
  uploadDropdownRef,
  analysisModeDropdownRef,
  webSearchDropdownRef,
}: AlfredToolsProps) => {
  const isSnbcUser = useFlags(state => state.getFeatureFlagState('snbc_user'));
  const isDocSearchEnabled = useFlags(state =>
    state.getFeatureFlagState('enable_doc_search')
  );

  return (
    <div className={styles.alfredTools}>
      <div className={styles.toolsWrapper}>
        {isAlfredPage && !isSnbcUser && (
          <RenderFeatureFlag requiredFlag={'alfred_user_upload'}>
            <UploadDropdown contentRef={uploadDropdownRef} />
          </RenderFeatureFlag>
        )}
        <div className={styles.leftTools}>
          {!isAlfredPage && allowedModes.length > 1 && isDocSearchEnabled && (
            <ChatModesButtonGroup compactMode variant="secondary" />
          )}
          {mode === 'research' && (
            <div className={styles.researchDropdowns}>
              <AnalysisModeDropdown
                contentRef={analysisModeDropdownRef}
                isMessagePending={isMessagePending}
              />
              <RenderFeatureFlag requiredFlag={'alfred_trusted_sources'}>
                <div className={styles.researchDropdownsDivider}>
                  <WebSearchDropdown contentRef={webSearchDropdownRef} />
                </div>
              </RenderFeatureFlag>
            </div>
          )}
        </div>
      </div>
      {showChildrenInTools && children}
    </div>
  );
};
